module.exports = __webpack_public_path__ + "assets/img/personalize-default-image.ecd34a54.jpg";